import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardPage from "../pages/dashboard_page/DashboardPage";
import LoginForm from "../components/auths/login_form/LoginForm";
import ForgotForm from "../components/auths/forget_form/ForgetForm";
import DashboardContainer from "../components/layout/dashboard_container/DashboardContainer";
import Agency from "../pages/agency/Agency";
import AgencyUsers from "../pages/users/AgencyUsers";
import Chargers from "../pages/chargers/Chargers";
import PageNotFound from "../pages/page_not_found/PageNotFound";
import Buses from "../pages/buses/Buses";
import VerificationScreen from "../components/auths/verification_screen/VerficationScreen";
import EnterNewPassword from "../components/auths/enter_newpassword/EnterNewPassword";
import Settings from "../pages/settings/Settings";
import BusData from "../pages/search_transit/BusData";
import ChargerData from "../pages/search_transit/ChargerData";
import CompareBuses from "../pages/compare_data/CompareBuses";
import CompareChargers from "../pages/compare_data/CompareChargers";

function ApplicationRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />
      <Route path="/forgot" element={<ForgotForm />} />
      <Route path="/verification" element={<VerificationScreen />} />
      <Route path="/enternewpassword" element={<EnterNewPassword />} />

      <Route path="/" element={<DashboardContainer />}>
        <Route index element={<DashboardPage />} />
        <Route path="/agency" element={<Agency />} />
        <Route path="/chargers" element={<Chargers />} />
        <Route path="/buses" element={<Buses />} />
        <Route path="/busdata" element={<BusData />} />
        <Route path="/chargerdata" element={<ChargerData />} />
        <Route path="/comparebuses" element={<CompareBuses />} />
        <Route path="/comparechargers" element={<CompareChargers />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/manage-agencies" element={<AgencyUsers />} />
      </Route>

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default ApplicationRoutes;
